/**
 * @component {"type":"Glossary","version":"1.0"}
 */

define('component-glossary',['knockout', 'helpers'], function(ko, helpers) {

    return function(parentVM, dataContext) {
        var self = this,
            trainingVM = parentVM.training;

        self.items = ko.computed(function() {
            var content = helpers.component.getContent(trainingVM.componentsJSON(), 'Glossary'),
                arr = helpers.component.parseProp(content, 'items', 'GlossaryItem');

            return (arr.length) ? arr : [];
        });

        self.getContent = function(index, prop) {
            var items = self.items(),
                item = (items) ? items[index] : null,
                res = (item && item.hasOwnProperty(prop) && item[prop]) ? item[prop] : (prop === 'body') ? '<p></p>' : '';

            if (dataContext.debugMode && dataContext.previewMode && !dataContext.productionMode && prop === 'body') {
                res = res.replace(/tokenId=onlineCourse/gi, 'tokenId=' + dataContext.tokenID);
            }

            return res;
        };

    };

});

